import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/views/MainLayout.vue';

import mainLayoutRouter from '@/router/mainLayoutRouter.js'
const routes = [
  {
    path: '',
    component: MainLayout,
    children:mainLayoutRouter
  }
]

const router = createRouter({
  base: process.env.VUE_APP_BASE_SERVER_URL,
  history: createWebHistory(process.env.VUE_APP_BASE_SERVER_URL),
  routes,
  mode:'history',
  // scrollBehavior(to, from, savedPosition) {
  //   // 如果有保存的滾動位置，返回該位置
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else {
  //     // 滾動到頁面的頂部
  //     return { left: 0, top: 0 };
  //   }
  // }
})

export default router
